import { Box, Center, Flex, Image, Text } from "@chakra-ui/react";
import { useChatsContext } from "../chats-context";
import { InputWhatsApp } from "./parts/input-send-message";
import { useWhatsAppSessionControls } from "./hooks/use-whats-app-session-controls";
import { MessageList } from "./parts/message-list";
import { ChatHeader } from "./parts/chat-header";
import { calcTelaChatsHeight } from "../..";
import { useAttendanceContext } from "contexts/attendance-context";

export function WhatsAppChat({
  telaAtendimento,
}: {
  telaAtendimento?: boolean;
}) {
  const { formControl, dispatch } = useAttendanceContext();
  const { selectedAttendance } = useChatsContext();
  const {
    wsSession,
    changeWhatsAppSession,
    chatStatus,
    loadingPhones,
    whatsAppPhones,
    currentSession,
    messages,
    contactInfo,
  } = useWhatsAppSessionControls({
    selectedAttendance,
    attendanceFullData: formControl.initialValues,
    dispatch,
  });
  const attendanceId = selectedAttendance?.id || formControl.values.id;

  return (
    <Flex
      css={{
        backgroundImage:
          "url(/assets/backgrounds/whats-app-bg.png), linear-gradient(to bottom, rgba(219, 216, 212, 0.3), rgba(219, 216, 212, 0.3))",
      }}
      backgroundRepeat="repeat, no-repeat"
      flexDir="column"
      gridArea={attendanceId ? "" : "auto / span 2"}
      maxH={
        telaAtendimento
          ? "calc(100vh - 30px - 36px - 30px - 25px)"
          : calcTelaChatsHeight()
      }
      h={telaAtendimento ? "100%" : calcTelaChatsHeight()}
      position={telaAtendimento ? "sticky" : "relative"}
      top={telaAtendimento ? "-5px" : undefined}
      w={telaAtendimento ? "100%" : undefined}
      borderRadius={telaAtendimento ? "6px" : undefined}
      overflow={telaAtendimento ? "hidden" : undefined}
    >
      {attendanceId ? (
        <>
          {/* Header */}
          <ChatHeader contactInfo={contactInfo} />
          {/* Chat */}
          <MessageList wsSession={wsSession} messages={messages} />
          {/* Input Message */}
          <Box>
            <InputWhatsApp
              whatsAppPhones={whatsAppPhones}
              loadingPhones={loadingPhones}
              chatStatus={chatStatus}
              changeWhatsAppSession={changeWhatsAppSession}
              wsSession={wsSession}
              currentSession={currentSession}
            />
          </Box>
        </>
      ) : (
        <Center bg="#f0f2f5" w="100%" flexDir="column" h="100%">
          <Image src="assets/backgrounds/tela-whats.png" w="340px" />
          <Text color="#41525d" fontSize="28px">
            WhatsApp
          </Text>
        </Center>
      )}
    </Flex>
  );
}
